/* ==========================================================================
   ProductCardHotels > Client > Config
   ========================================================================== */

/* Import modules */

/* Config */
const config = {
    component: 'ProductCardHotels',
    type: {
        image: 'product-card-hotels-image'
    },
    css: {
        base: 'product-card-hotels',
        image: 'product-card-hotels__image'
    },
    image: {
        resize: {
            width: 268,
            height: 145,
            quality: 97
        }
    }
};

module.exports = () => config;
